export default [
    {
        path: "bank-accounts",
        name: "treasury-bank-accounts",
        redirect: { name: "treasury-bank-accounts-list" },
        component: () => import("@/views/commons/bank-accounts/BankAccounts.vue"),
        meta: {
            section: 38,
            breadcrumb: [
                {
                    text: "Bank accounts"
                },
            ],
            tabs: [
                {
                    title: "Bank accounts",
                    name: "treasury-bank-accounts-list",
                },
            ],
        },
        children: [
            {
                path: "list",
                name: "treasury-bank-accounts-list",
                component: () =>
                    import("@/views/commons/bank-accounts/components/BankAccountsTable.vue"),
                meta: {
                    section: 38,
                    tab: "pending",
                    pageTitle: "Bank accounts",
                    breadcrumb: [
                        {
                            text: "List",
                            active: true,
                        },
                    ],
                },
            },
        ],
    }
]